<script setup lang="ts">
const route = useRoute()
const title = computed(() => route.meta.title as string ?? '')
const router = useRouter()

function goBack() {
  if (window.history.length > 1) {
    router.back()
    return
  }

  router.push(route.path.startsWith('/signup') ? '/signup' : '/login')
}
</script>

<template>
  <div class="flex min-h-screen flex-col bg-background lg:bg-muted/40">
    <header class="flex h-14 items-center gap-2 px-4">
      <button
        type="button"
        aria-label="Назад"
        class="flex size-9 shrink-0 items-center justify-center rounded-full text-foreground transition-colors hover:bg-muted"
        @click="goBack"
      >
        <Icon name="tabler:chevron-left" class="size-5" />
      </button>
      <h1 class="flex-1 truncate text-center text-base font-semibold">
        {{ title }}
      </h1>
      <div class="size-9 shrink-0" />
    </header>

    <div class="flex flex-1 flex-col lg:mx-auto lg:my-8 lg:w-full lg:max-w-2xl lg:rounded-3xl lg:bg-background lg:shadow-sm">
      <slot />
    </div>
  </div>
</template>
